module.exports = __webpack_public_path__ + "static/media/Avatar3b.4e733f28.png";